$(document).on('click', '.tab-btn', function () {
  var tab = $(this).data('tab');

  $('.tab-btn')
    .removeClass('text-grass-500 border-grass-500')
    .addClass('text-slate-500 border-transparent');
  $(this)
    .removeClass('text-slate-500 border-transparent')
    .addClass('text-grass-500 border-grass-500');

  $('.tab-panel').addClass('hidden');
  $('.tab-panel[data-tab="' + tab + '"]').removeClass('hidden');
});
